module.exports = __webpack_public_path__ + "static/img/5.ccb6ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/5.png
// module id = 04eA
// module chunks = 0